import { make } from 'vuex-pathify';
import Cookies from 'js-cookie';
import { addSeconds, isAfter, parseISO } from 'date-fns';
import { post } from '../../http';

const defaultState = {
  timeBomb: null,
  token: '',
};

const mutations = {
  ...make.mutations(defaultState),

  RESET_STATE(s) {
    Object.assign(s, defaultState);
  },
};

const getters = {
  ...make.getters(defaultState),
};

const actions = ({
  MGO_API,
}) => ({
  reset({ commit }) {
    commit('RESET_STATE');
  },

  async authenticateRapidKey({ commit }, { visitId, token }) {
    {
      const { token: rkToken, expiresAt } = JSON.parse(Cookies.get('dprk') || '{}');
      if (isAfter(parseISO(expiresAt), new Date())) {
        commit('SET_TOKEN', rkToken);
        return true;
      }
    }

    const { access_token: rkToken, expires_in: expiresIn } = await post(`${MGO_API}/mgo-api/api/v1/datapower/rapidkey/token?visitId=${visitId}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (rkToken) {
      commit('SET_TOKEN', rkToken);
      Cookies.set('dprk', {
        token: rkToken,
        expiresAt: addSeconds(new Date(), expiresIn),
      });
    }

    return true;
  },

  async addressSearch(ctx, {
    streetAddress = '',
    cityName = '',
    state = '',
    zipcode = '',
    token,
    visitId,
    origin,
  }) {
    if (!ctx.state.token) {
      await ctx.dispatch('authenticateRapidKey', { token, visitId, origin });
    }
    return post(`${origin}/search/address`, {
      streetAddress, cityName, state, zipcode,
    }, {
      headers: {
        Authorization: `Bearer ${ctx.state.token}`,
      },
    });
  },

  async zipcodeSearch(ctx, {
    cityName = '',
    state = '',
    zip = '',
    token,
    visitId,
    origin,
  }) {
    if (!ctx.state.token) {
      await ctx.dispatch('authenticateRapidKey', { token, visitId, origin });
    }
    return post(`${origin}/search/zcs`, {
      cityName,
      state,
      zip,
    }, {
      headers: {
        Authorization: `Bearer ${ctx.state.token}`,
      },
    });
  },
});

export default ({
  MGO_API,
}) => ({
  namespaced: true,
  state: defaultState,
  mutations,
  getters,
  actions: actions({
    MGO_API,
  }),
});
